module.exports = __webpack_public_path__ + "statics/img/ycz3.df098608.png";